import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-percent",
  "use": "icon-percent-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-percent\"><defs><style type=\"text/css\"></style></defs><path d=\"M482.1 64v59.7C251.2 123.7 64 310.9 64 541.9 64 772.8 251.2 960 482.1 960c230.9 0 418.1-187.2 418.1-418.1H960C960 277.9 746.1 64 482.1 64z m59.8 64C724.7 154.3 869.7 299.3 896 482.1H541.9V128z m-59.8 772.3c-197.6 0-358.4-160.8-358.4-358.4s160.8-358.4 358.4-358.4v358.4h358.4c0 197.6-160.7 358.4-358.4 358.4z\" p-id=\"22120\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/percent.svg
// module id = SA3L
// module chunks = 250